/**
 * Lightweight slug registries for route matching.
 * These only contain slug strings — no content data.
 * Keeps the main bundle small by avoiding importing the full data files.
 */

export const glossarySlugs = new Set([
  "vinyl-record", "compact-disc", "lp", "ep", "single", "45-rpm",
  "picture-disc", "colored-vinyl", "box-set", "turntable", "record-player",
  "hi-fi", "stylus", "first-pressing", "reissue", "remaster",
  "record-grading", "mint-condition", "gatefold", "obi-strip", "dead-wax",
  "crate-digging", "180-gram-vinyl", "lossless-audio", "mastering",
  "surface-noise", "audiophile", "discogs", "record-store-day",
  "liner-notes", "music-ownership", "pressing-plant",
]);

export const comparisonSlugs = new Set([
  "vinyl-vs-cd", "streaming-vs-vinyl", "streaming-vs-cd", "vinyl-vs-digital",
  "180g-vinyl-vs-standard-vinyl", "first-pressing-vs-reissue",
  "spotify-vs-owning-music", "record-player-vs-turntable",
]);

export const personaSlugs = new Set([
  "beginners", "audiophiles", "spotify-users",
  "collectors", "gift-shoppers", "gen-z",
]);

export const curationSlugs = new Set([
  "best-entry-level-turntables", "best-powered-speakers-for-vinyl",
  "best-phono-preamps", "best-vinyl-records-for-beginners",
  "best-audiophile-pressings", "best-record-cleaning-kits",
  "best-vinyl-storage-solutions", "best-record-stores-online",
  "best-budget-vinyl-setup",
]);

export const guideSlugs = new Set([
  "how-to-start-vinyl-collection", "how-to-start-cd-collection",
  "how-to-set-up-turntable", "how-to-clean-vinyl-records",
  "how-to-use-discogs", "how-to-rip-cds-to-flac",
  "how-to-identify-vinyl-pressing",
]);
